module.exports = __webpack_public_path__ + "img/crypto-exchange-gold.5d57512c.svg";